<template>
  <dairy-list :username="username"
              :role="role"
              @apierror="setApiError"
              @apierrortext="setApiErrorText"></dairy-list>
</template>

<script>
import DairyList from '@/components/control/dairy/List'

export default {
  name: 'Control',
  props: ['username', 'role'],
  emits: ['apierror', 'apierrortext'],
  components: {
    DairyList,
  },
  methods: {
    setApiError: function (isError) {
      this.$emit('apierror', isError)
    },
    setApiErrorText: function (text) {
      this.$emit('apierrortext', text)
    }
  },
}
</script>